let black    =     "#111111";
let white    =     "#ffffff";
let blue     =     "#192767";
let peach    =     "#fd5756";
let yellow   =     "#f3de4f";

const Color = {
  black,
  white,
  blue,
  peach,
  yellow
}

export default Color;



// WEBPACK FOOTER //
// ./src/components/color/index.js